import { render, staticRenderFns } from "./FinancialMentionField.vue?vue&type=template&id=220bdd24&scoped=true&"
import script from "./FinancialMentionField.vue?vue&type=script&lang=ts&"
export * from "./FinancialMentionField.vue?vue&type=script&lang=ts&"
import style0 from "./FinancialMentionField.vue?vue&type=style&index=0&id=220bdd24&scoped=true&lang=scss&"
import style1 from "./FinancialMentionField.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./FinancialMentionField.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bdd24",
  null
  
)

export default component.exports